export default () => ({
  trigger: {
    name: 'insurance_selector.close_insurance_modal',
    params: {},
  },
  config: {
    event: {
      name: 'close',
      params: {
        sub_feature: 'shopping_cart',
      },
    },
  },
});
